import React from "react";
import HeaderSelection from "../../header/coworker";
import UserInfoHeading from "../../User/container";

export const Header = ({ title, personalId }) => {
  return (
    <>
      <HeaderSelection href="#/tm/coworker/mycourses" />
      <UserInfoHeading personalId={personalId} pageTitle={title} />
    </>
  );
};

export const HeadingPage = ({ heading }) => (
  <div className="flex flex-space-b">
    <h1 className="page-header">{heading}</h1>
  </div>
);

export const HeadingPanel = ({ title }) => (
  <div className="panel-header">
    <div className="icon-courses" aria-hidden="true" />
    <h2 className="panel-heading">
      <span className="paneltitle">{title}</span>
    </h2>
  </div>
);
